import { Badge as ShadcnBadge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface RiskBadgeProps {
  risk: 'low' | 'medium' | 'high' | 'unknown';
  className?: string;
}

export const RiskBadge = ({ risk, className }: RiskBadgeProps) => {
  const variants = {
    low: "bg-success text-success-foreground",
    medium: "bg-warning text-warning-foreground",
    high: "bg-destructive text-destructive-foreground",
    unknown: "bg-muted text-muted-foreground",
  };

  return (
    <ShadcnBadge className={cn(variants[risk], className)}>
      Risk: {risk.charAt(0).toUpperCase() + risk.slice(1)}
    </ShadcnBadge>
  );
};

interface VerifiedBadgeProps {
  className?: string;
}

export const VerifiedBadge = ({ className }: VerifiedBadgeProps) => {
  return (
    <ShadcnBadge variant="secondary" className={cn("bg-info text-info-foreground", className)}>
      ✓ Verified
    </ShadcnBadge>
  );
};
